import { Component, Input } from '@angular/core';

@Component({
    selector: 'link-renders',
    template: require('./chat.link-renders.component.html')
})
export class LinkRendersComponent {

    @Input() msg: any = null;

    /** Number of preview cards shown before the rest are collapsed. */
    @Input() collapsedLimit: number = 1;

    expanded: boolean = false;

    constructor() { }

    ngOnInit() {}

    /** Only generic/tracker-item preview cards are collapsible. */
    private get previews(): any[] {
        return (this.msg?.renders || []).filter((r: any) => r.type == 'preview');
    }

    get hiddenCount(): number {
        return Math.max(0, this.previews.length - this.collapsedLimit);
    }

    isVisible(link: any): boolean {
        if (this.expanded || link.type != 'preview') {
            return true;
        }
        return this.previews.indexOf(link) < this.collapsedLimit;
    }

    toggle() {
        this.expanded = !this.expanded;
    }

}
